/**
 * The plan feature each gated route needs (whereis-2).
 *
 * Was written into `router.tsx` JSX as `<EntitledRoute feature="...">`. Data
 * now, so the router and the search box read one table: the search box says
 * "Not on your plan yet" for exactly the pages the router walls off, using the
 * same `has()` rule `EntitledRoute` uses.
 *
 * Estimates is not here on purpose (founder, 9 Sep 2026: see `router.tsx`).
 */
export const ROUTE_FEATURE = {
    '/credit-notes': 'credit_debit_notes',
    '/debit-notes': 'credit_debit_notes',
    '/recurring-invoices': 'recurring',
    '/recurring-bills': 'recurring',
    '/inventory': 'inventory',
    '/manufacturing': 'manufacturing',
    '/multi-currency': 'multi_currency',
    '/report-builder': 'report_builder',
    '/consolidation': 'consolidation',
    '/payment-links': 'payment_links',
    '/bank-feeds': 'bank_feed',
} as const satisfies Record<string, string>;

export type GatedRoute = keyof typeof ROUTE_FEATURE;
